define('taoQtiItem/qtiXmlRenderer/renderers/choices/Hottext',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'hottext',
        template : tpl
    };
});
